(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.__thhInit) return;
    root.__thhInit = true;

    var sectionId = root.getAttribute('data-section-id');
    var productUrl = root.getAttribute('data-product-url');
    var variants = [];
    try {
      var tag = root.querySelector('[data-thh-variants]');
      variants = tag ? JSON.parse(tag.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    // Buyer choices that must survive the Section Rendering API re-render
    // (root.innerHTML is replaced on every flavour / pack switch).
    // picks only holds flavours the customer changed by hand, keyed "paid-0", "free-2"…
    var state = { plan: null, tier: null, picks: {} };

    function currentSelection() {
      var sel = { '1': null, '2': null };
      root.querySelectorAll('[data-thh-option][aria-pressed="true"]').forEach(function (b) {
        sel[b.getAttribute('data-thh-option')] = b.getAttribute('data-value');
      });
      return sel;
    }

    function findVariant(opt, value) {
      var sel = currentSelection();
      sel[opt] = value;
      var match = variants.find(function (v) {
        var ok1 = sel['1'] == null || v.option1 === sel['1'];
        var ok2 = sel['2'] == null || v.option2 === sel['2'];
        return ok1 && ok2;
      });
      if (match) return match;
      return variants.find(function (v) {
        return String(opt === '1' ? v.option1 : v.option2) === value;
      });
    }

    function switchVariant(variant) {
      if (!variant) return;
      if (variant.primary) root.style.setProperty('--thh-primary', variant.primary);
      if (variant.bg) root.style.setProperty('--thh-bg', variant.bg);

      try {
        window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
      } catch (e) {}

      fetch(productUrl + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-thh-pdp]');
          if (next) {
            root.innerHTML = next.innerHTML;
            var style = next.getAttribute('style');
            if (style) root.setAttribute('style', style);
            restoreState();
          }
        })
        .catch(function () {});

      syncSiblingSections(variant.id);
    }

    // Keep other THH sections on the page (e.g. terpenes) in sync with the variant.
    // Any section marked [data-thh-sync-section] is re-rendered via the Section Rendering API.
    function syncSiblingSections(variantId) {
      document.querySelectorAll('[data-thh-sync-section]').forEach(function (el) {
        var sid = el.getAttribute('data-section-id');
        if (!sid) return;
        var wrapper = document.getElementById('shopify-section-' + sid) || el.parentElement;
        if (!wrapper) return;
        fetch(productUrl + '?variant=' + variantId + '&section_id=' + sid)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (html && html.trim()) {
              wrapper.innerHTML = html;
              document.dispatchEvent(new CustomEvent('thh:synced'));
            }
          })
          .catch(function () {});
      });
    }

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withSep = function (sep, dec) {
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (dec ? dec + parts[1] : '');
      };
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        if (key === 'amount_no_decimals') return withSep(',', '').split('.')[0];
        if (key === 'amount_with_comma_separator') return withSep('.', ',');
        if (key === 'amount_no_decimals_with_comma_separator') return withSep('.', '');
        return withSep(',', '.');
      });
    }

    function currentVariant() {
      var input = root.querySelector('[data-thh-variant-id]');
      var id = input ? Number(input.value) : null;
      return variants.find(function (v) { return v.id === id; }) || null;
    }

    function selectedPlanValue() {
      var r = root.querySelector('[data-thh-plan-radio]:checked');
      return r ? r.value : null;
    }

    function selectedTier() {
      var r = root.querySelector('[data-thh-tier-radio]:checked');
      return r ? r.closest('[data-thh-tier]') : null;
    }

    // Variant for each pack in a tier: the slot's flavour + the bundle's pack size.
    function tierVariants(tier) {
      var base = currentVariant();
      if (!tier || !base) return [];
      var paid = Number(tier.getAttribute('data-paid')) || 0;
      var free = Number(tier.getAttribute('data-free')) || 0;
      var selects = tier.querySelectorAll('[data-thh-slot]');
      var list = [];
      for (var i = 0; i < paid + free; i++) {
        var flavour = selects[i] ? selects[i].value : base.option1;
        var match = variants.find(function (v) {
          return v.option1 === flavour && (base.option2 == null || v.option2 === base.option2);
        });
        list.push(match || null);
      }
      return list;
    }

    // BXGY discounts the cheapest packs, so price the bundle the same way.
    function tierPricing(tier) {
      var list = tierVariants(tier);
      var free = Number(tier.getAttribute('data-free')) || 0;
      var prices = list.map(function (v) { return v ? v.price : 0; }).sort(function (a, b) { return a - b; });
      var compare = prices.reduce(function (s, p) { return s + p; }, 0);
      var discount = prices.slice(0, free).reduce(function (s, p) { return s + p; }, 0);
      var available = list.length > 0 && list.every(function (v) { return v && v.available; });
      return { total: compare - discount, compare: compare, save: discount, units: list.length, available: available };
    }

    function updateTierPrices() {
      root.querySelectorAll('[data-thh-tier]').forEach(function (tier) {
        var p = tierPricing(tier);
        var now = tier.querySelector('[data-thh-tier-now]');
        var cmp = tier.querySelector('[data-thh-tier-compare]');
        var save = tier.querySelector('[data-thh-tier-save]');
        var perShot = tier.querySelector('[data-thh-tier-pershot]');
        if (now) now.textContent = formatMoney(p.total);
        if (cmp) { cmp.textContent = formatMoney(p.compare); cmp.hidden = p.save <= 0; }
        if (save) { save.textContent = 'SAVE ' + formatMoney(p.save); save.hidden = p.save <= 0; }
        if (perShot) {
          var shots = parseInt((currentVariant() || {}).option2, 10) || 0;
          if (shots > 0 && p.units > 0) perShot.textContent = formatMoney(Math.round(p.total / (shots * p.units)));
        }
      });
    }

    // ATC label, disabled state and the no-JS quantity fallback for the active plan/tier.
    function updateAtc() {
      var atcBtn = root.querySelector('.thh-pdp__atc');
      var atc = root.querySelector('[data-thh-atc-label]');
      var qty = root.querySelector('[data-thh-quantity]');
      var radio = root.querySelector('[data-thh-plan-radio]:checked');
      var base = currentVariant();
      if (!atcBtn || !atc || !radio) return;

      var label = atcBtn.getAttribute('data-thh-atc-text') || 'Add to cart';
      var soldOut = atcBtn.getAttribute('data-thh-soldout-text') || 'Sold out';
      var tier = radio.value === 'onetime' ? selectedTier() : null;

      if (tier) {
        var p = tierPricing(tier);
        atcBtn.disabled = !p.available;
        if (qty) qty.value = String(p.units);
        if (!p.available) { atc.textContent = soldOut; return; }
        atc.textContent = label + '  ' + formatMoney(p.total);
        if (p.compare > p.total) {
          var s = document.createElement('s');
          s.className = 'thh-pdp__atc-compare';
          s.textContent = formatMoney(p.compare);
          atc.appendChild(document.createTextNode(' '));
          atc.appendChild(s);
        }
        return;
      }

      if (qty) qty.value = '1';
      var available = base ? base.available : !atcBtn.disabled;
      atcBtn.disabled = !available;
      atc.textContent = available ? label + '  ' + (radio.getAttribute('data-price') || '') : soldOut;
    }

    function selectTier(radio) {
      if (!radio) return;
      root.querySelectorAll('[data-thh-tier]').forEach(function (t) {
        t.classList.toggle('is-selected', t.contains(radio));
      });
      state.tier = radio.value;
      updateAtc();
    }

    function onSlotChange(select) {
      var key = select.getAttribute('data-kind') + '-' + select.getAttribute('data-index');
      state.picks[key] = select.value;
      // Same pack position stays in sync across tiers, so switching tier keeps the picks.
      root.querySelectorAll('[data-thh-slot]').forEach(function (s) {
        if (s !== select && s.getAttribute('data-kind') + '-' + s.getAttribute('data-index') === key) s.value = select.value;
      });
      updateTierPrices();
      updateAtc();
    }

    function restoreState() {
      if (state.plan) {
        var planRadio = root.querySelector('[data-thh-plan-radio][value="' + state.plan + '"]');
        if (planRadio) { planRadio.checked = true; selectPlan(planRadio); }
      }
      if (state.tier) {
        var tierRadio = root.querySelector('[data-thh-tier-radio][value="' + state.tier + '"]');
        if (tierRadio) { tierRadio.checked = true; selectTier(tierRadio); }
      }
      root.querySelectorAll('[data-thh-slot]').forEach(function (s) {
        var pick = state.picks[s.getAttribute('data-kind') + '-' + s.getAttribute('data-index')];
        if (!pick) return;
        var opt = Array.prototype.find.call(s.options, function (o) { return o.value === pick && !o.disabled; });
        if (opt) s.value = pick;
      });
      updateTierPrices();
      updateAtc();
    }

    // Cart lines for the selected one-time tier (one line per flavour), or null to post the form as-is.
    // With the drawer's free-pack picker running (assets/b2g1-cart.js), the free slots go in as its
    // gift lines — FREE badge, no stepper or Autoship — and last, so the discount lands on them.
    root.__thhBundleItems = function () {
      if (selectedPlanValue() !== 'onetime') return null;
      var tier = selectedTier();
      if (!tier) return null;
      var paidCount = Number(tier.getAttribute('data-paid')) || 0;
      var gifts = window.THHB2G1 && window.THHB2G1.giftProperties && window.THHPickACard ? window.THHB2G1.giftProperties() : null;
      var lines = [];
      var byKey = {};
      tierVariants(tier).forEach(function (v, i) {
        if (!v) return;
        var gift = gifts && i >= paidCount;
        var key = v.id + (gift ? ':gift' : '');
        if (!byKey[key]) {
          byKey[key] = { id: v.id, quantity: 0 };
          if (gift) byKey[key].properties = gifts;
          lines.push(byKey[key]);
        }
        byKey[key].quantity += 1;
      });
      return lines.filter(function (l) { return !l.properties; }).concat(lines.filter(function (l) { return l.properties; }));
    };

    // Plan toggle (subscribe / one-time) — updates price, per-shot, save, ATC, selling_plan
    function selectPlan(radio) {
      if (!radio) return;
      root.querySelectorAll('.thh-pdp__plan').forEach(function (p) {
        p.classList.toggle('is-selected', p.contains(radio));
      });
      var price = radio.getAttribute('data-price') || '';
      var pershot = radio.getAttribute('data-pershot') || '';
      var planId = radio.getAttribute('data-plan-id') || '';
      var isSub = radio.value === 'subscribe';
      state.plan = radio.value;

      var sellingPlan = root.querySelector('[data-thh-selling-plan]');
      if (sellingPlan) sellingPlan.value = planId;

      var priceEl = root.querySelector('[data-thh-price]');
      if (priceEl && price) priceEl.textContent = price;

      var perShotEl = root.querySelector('[data-thh-pershot]');
      if (perShotEl && pershot) perShotEl.textContent = 'ONLY ' + pershot + ' PER SHOT';

      var block = root.querySelector('[data-thh-price-block]') || root.querySelector('.thh-pdp__price-block');
      var saveEl = root.querySelector('[data-thh-save]');
      if (block && saveEl) {
        var save = block.getAttribute(isSub ? 'data-thh-sub-save' : 'data-thh-onetime-save') || '';
        if (save) { saveEl.textContent = 'SAVE ' + save; saveEl.hidden = false; }
        else { saveEl.textContent = ''; saveEl.hidden = true; }
      }

      updateAtc();
    }

    function activateTab(tab) {
      var panelId = tab.getAttribute('data-panel');
      root.querySelectorAll('[data-thh-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      root.querySelectorAll('[data-thh-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-thh-panel') !== panelId;
      });
    }

    function showMedia(index) {
      var thumbs = root.querySelectorAll('[data-thh-media-thumb]');
      if (!thumbs.length || index < 0 || index >= thumbs.length) return;
      var mainImg = root.querySelector('[data-thh-media-main] img');
      var thumbImg = thumbs[index].querySelector('img');
      if (mainImg && thumbImg) {
        mainImg.src = thumbImg.getAttribute('data-full') || thumbImg.src;
        mainImg.removeAttribute('srcset');
      }
      thumbs.forEach(function (t, i) { t.classList.toggle('is-selected', i === index); });
      root.setAttribute('data-thh-media-index', String(index));
    }

    function stepMedia(dir) {
      var count = root.querySelectorAll('[data-thh-media-thumb]').length;
      if (!count) return;
      var index = parseInt(root.getAttribute('data-thh-media-index') || '0', 10) + dir;
      showMedia((index + count) % count);
    }

    function scrollStrip(dir) {
      var strip = root.querySelector('[data-thh-strip]');
      if (strip) strip.scrollBy({ left: dir * 200, behavior: 'smooth' });
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-thh-option]');
      if (opt) {
        switchVariant(findVariant(opt.getAttribute('data-thh-option'), opt.getAttribute('data-value')));
        return;
      }
      var tab = e.target.closest('[data-thh-tab]');
      if (tab) { activateTab(tab); return; }
      var thumb = e.target.closest('[data-thh-media-thumb]');
      if (thumb) { showMedia(parseInt(thumb.getAttribute('data-index'), 10)); return; }
      if (e.target.closest('[data-thh-media-prev]')) { stepMedia(-1); return; }
      if (e.target.closest('[data-thh-media-next]')) { stepMedia(1); return; }
      if (e.target.closest('[data-thh-strip-prev]')) { scrollStrip(-1); return; }
      if (e.target.closest('[data-thh-strip-next]')) { scrollStrip(1); return; }
    });

    root.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-thh-plan-radio]');
      if (radio) { selectPlan(radio); return; }
      var tierRadio = e.target.closest('[data-thh-tier-radio]');
      if (tierRadio) { selectTier(tierRadio); return; }
      var slot = e.target.closest('[data-thh-slot]');
      if (slot) onSlotChange(slot);
    });

    root.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[data-thh-tab]');
      if (!tab) return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-thh-tab]'));
      var i = tabs.indexOf(tab);
      if (e.key === 'ArrowRight') { tabs[(i + 1) % tabs.length].focus(); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { tabs[(i - 1 + tabs.length) % tabs.length].focus(); e.preventDefault(); }
      else if (e.key === 'Enter' || e.key === ' ') { activateTab(tab); e.preventDefault(); }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-thh-pdp]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-thh-pdp]');
    if (root) initRoot(root);
  });

  /* ---------- Global PDP behaviours (add-to-cart drawer + scroll CTAs) ---------- */
  function thhCartAddUrl() {
    return ((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add') + '.js';
  }
  function thhOpenCart() {
    // THHCart (assets/thh-cart-drawer.js) refreshes and opens whichever drawer
    // is live: Rebuy's while Smart Cart is on, the theme's own otherwise.
    if (window.THHCart) { window.THHCart.refresh(); window.THHCart.open(); return; }
    // Rebuy Smart Cart is the live drawer: refresh it from /cart.js, then open it.
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') {
        Promise.resolve(window.Rebuy.Cart.fetchCart()).then(function () {
          if (window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') window.Rebuy.SmartCart.show();
        });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
    try {
      if (window.Alpine && window.Alpine.store && window.Alpine.store('modals')) {
        window.Alpine.store('modals').open('cart');
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('theme:open:cart-drawer', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart-will-open', { bubbles: true }));
  }
  // While Buy 2 Get 1 runs as a code discount, the code lives in
  // snippets/b2g1-cart-config.liquid (window.THHB2G1Config). Apply it before adding a
  // tier with free packs; once that code is blanked for the automatic discount, this
  // does nothing.
  function thhApplyOfferCode(needed) {
    var cfg = window.THHB2G1Config;
    if (!needed || !cfg || cfg.enabled === false || !cfg.discountCode) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .catch(function () {});
  }
  function thhAddToCart(payload) {
    var opts = { method: 'POST', headers: { 'Accept': 'application/json' } };
    if (payload instanceof FormData) {
      opts.body = payload;
    } else {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(payload);
    }
    return fetch(thhCartAddUrl(), opts).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.status) { throw data; }
      thhOpenCart();
      return data;
    });
  }

  // Window + capture phase so this runs before Rebuy Smart Cart, which calls
  // stopPropagation() on add-to-cart submits without cancelling them. Listening on
  // document let the native post through: id + quantity only, i.e. the page flavour × N.
  window.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('.thh-pdp__form');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('.thh-pdp__atc');
    var root = form.closest('[data-thh-pdp]');
    var errorEl = root && root.querySelector('[data-thh-error]');
    var items = root && root.__thhBundleItems ? root.__thhBundleItems() : null;
    var tier = items && root.querySelector('[data-thh-tier-radio]:checked');
    var freePacks = tier ? Number(tier.closest('[data-thh-tier]').getAttribute('data-free')) || 0 : 0;
    if (errorEl) errorEl.hidden = true;
    if (btn) btn.disabled = true;
    thhApplyOfferCode(freePacks > 0)
      .then(function () { return thhAddToCart(items ? { items: items } : new FormData(form)); })
      .catch(function (err) {
        // A bundle can't fall back to a plain form post (it would add one flavour only)
        if (!items) { form.submit(); return; }
        if (errorEl) {
          errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);

  document.addEventListener('click', function (e) {
    // Benefits "Shop Now" -> scroll up to the buy box
    var shop = e.target.closest('.thh-benefits__btn');
    if (shop) {
      var main = document.querySelector('[data-thh-pdp]');
      if (main) { e.preventDefault(); main.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    // Reviews "Read More Reviews" -> scroll to Junip reviews (when no explicit URL)
    var rev = e.target.closest('.thh-reviews__btn');
    if (rev) {
      var href = rev.getAttribute('href');
      if (!href || href === '#') {
        var jn = document.querySelector('[data-junip-product-review], [data-junip-product-rating], [class*="junip"], [id*="junip"]');
        if (jn) { e.preventDefault(); (jn.closest('.shopify-section') || jn).scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
      return;
    }
    // Bundle "Buy Now" -> add its product to cart + open drawer
    var badd = e.target.closest('[data-thh-bundle-add]');
    if (badd) {
      var vid = badd.getAttribute('data-variant-id');
      if (vid) {
        e.preventDefault();
        badd.setAttribute('aria-busy', 'true');
        thhAddToCart({ items: [{ id: vid, quantity: 1 }] })
          .catch(function () {})
          .then(function () { badd.removeAttribute('aria-busy'); });
      }
      return;
    }
  });
})();
